<template>
  <label class="d-flex align-items-center mb-0 w-50">
    <span class="mr-1">{{ $t("lbl_EMPBE_Start") }}</span>
    <DateInput :value="value" :format="format" :id="id" :placeholder="$t('lbl_EMPBE_DateFormatYYYYMMDD')"
      @change="handleChange"/>
    <kbutton :theme-color="'base'" @click="handleClear"><i class="icon-close f-12 mr-0"></i></kbutton>
  </label>
</template>
  
<script>
import { DateInput } from "@progress/kendo-vue-dateinputs";
import { Button } from '@progress/kendo-vue-buttons';
export default {
  components: {
    DateInput,
    'kbutton': Button,
  },
  inheritAttrs: false,
  props: {
    value: Date,
    format: String,
    id: String,
    min: Date,
    max: Date,
    disabled: Boolean,
    label: String,
  },
  computed: {
  },
  methods: {
    handleChange(e) {
      this.$emit("change", e);
    },
    handleClear(e) {
      this.$parent.currentValue.start = null;
      this.$parent.$emit("change", {value: this.$parent.currentValue});
    },
  },
};
</script>